import { render, staticRenderFns } from "./points-plan-success.vue?vue&type=template&id=3dc165e8&scoped=true&"
import script from "./points-plan-success.vue?vue&type=script&lang=js&"
export * from "./points-plan-success.vue?vue&type=script&lang=js&"
import style0 from "./points-plan-success.vue?vue&type=style&index=0&id=3dc165e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc165e8",
  null
  
)

export default component.exports